<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Protocolos de Queda</h5>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="f.aluno"
        placeholder="Filtrar por Aluno"
        class="form-control"
        @input="filtrar"
      />

      <input
        v-model="f.instrutor"
        placeholder="Filtrar por Instrutor"
        class="form-control"
        @input="filtrar"
      />

      <input
        v-model="f.data_inicio"
        type="date"
        class="form-control"
        title="Data início"
        @change="filtrar"
      />

      <input
        v-model="f.data_fim"
        type="date"
        class="form-control"
        title="Data fim"
        @change="filtrar"
      />

      <select v-model="f.status" class="form-control" @change="filtrar">
        <option value="">Todos os status</option>
        <option value="RASCUNHO">Rascunho</option>
        <option value="ENVIADO_RECEPCAO">Enviado à Recepção</option>
        <option value="AGUARDANDO_ASSINATURAS">Aguardando Assinaturas</option>
        <option value="CONCLUIDO">Concluído</option>
      </select>

      <select v-model="f.nivel_cor" class="form-control" @change="filtrar">
        <option value="">Todas as severidades</option>
        <option value="vermelho">🔴 Vermelho</option>
        <option value="amarelo">🟡 Amarelo</option>
        <option value="roxo">🟣 Roxo</option>
        <option value="verde">🟢 Verde</option>
      </select>

      <select v-model="f.contato_familia" class="form-control" @change="filtrar">
        <option value="">Contato família (Todos)</option>
        <option value="true">Sim</option>
        <option value="false">Não</option>
      </select>

      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('id')">
              ID {{ arrow('id') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('aluno')">
              Aluno {{ arrow('aluno') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('animal')">
                Animal {{ arrow('animal') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('instrutor')">
              Instrutor {{ arrow('instrutor') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('turma')">
              Turma {{ arrow('turma') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('data_aula')">
              Data Aula {{ arrow('data_aula') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('nivel_cor')">
              Nível {{ arrow('nivel_cor') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('status')">
              Status {{ arrow('status') }}
            </button>
          </th>

          <th>
            <button class="btn btn-link p-0" @click="sort('contato_familia')">
              Contato Família {{ arrow('contato_familia') }}
            </button>
          </th>

          <th class="text-end">Ações</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.aluno }}</td>
          <td>{{ item.animal_nome || '—' }}</td>
          <td>{{ item.instrutor || '—' }}</td>
          <td>{{ item.turma || '—' }}</td>
          <td>{{ item.data_aula ? globalUtils.formatarData(item.data_aula) : '' }}</td>

          <td>
            <span class="dot" :class="item.nivel_cor || 'normal'" :title="item.nivel_cor || 'normal'"></span>
          </td>

          <td class="text-nowrap">{{ item.status }}</td>

          <td>
            <span v-if="item.contato_familia === true" class="badge bg-success">Sim</span>
            <span v-else class="badge bg-secondary">Não</span>
          </td>

          <td class="text-end">
            <i
                class="bi bi-eye text-primary mx-1"
                title="Abrir protocolo"
                style="cursor: pointer;"
                @click="abrirProtocolo(item)"
            />

            <i
              class="mx-1"
              :class="pdfIconClass(item)"
              :title="pdfTitle(item)"
              :style="{ cursor: canGerarPdf(item) ? 'pointer' : 'not-allowed' }"
              @click="onClickGerarPdf(item)"
            />

          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>

      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
        />
      </div>

      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
        />
      </div>
    </div>

    <!-- Modal Protocolo -->
    <ProtocoloQueda
      v-if="showModalProtocoloQueda"
      :visible="showModalProtocoloQueda"
      :registro="selectedProtocoloQueda"
      :readOnly="true"
      :workflow="true"
      :saveToBackend="true"
      @salvou="onSalvouProtocolo"
      @close="fecharModalProtocolo"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed, getCurrentInstance } from 'vue';
import axios from '@/services/axios';
import { useSortableTable } from '@/utils/useSortableTable';
import globalUtils from '@/utils/globalUtils';
import { BButton, BFormSelect, BPagination } from 'bootstrap-vue-next';
import ProtocoloQueda from '@/components/modals/ProtocoloQueda.vue';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const instance = getCurrentInstance();

// ✅ compatível com variações de bundler (default vs named)
pdfMake.vfs =
  pdfFonts?.pdfMake?.vfs ||
  pdfFonts?.vfs ||
  pdfFonts?.default?.pdfMake?.vfs ||
  pdfFonts?.default?.vfs;

const {
  items,
  totalItems,
  page,
  limit,
  filters,
  sort,
  arrow,
  load
} = useSortableTable(
  '/operacional/alunos-quedas/listagem',
  { key: 'id', order: 'desc' }
);

const f = computed(() => (filters?.value ? filters.value : filters));

const pageOptions = [10, 15, 20, 25, 50];

const startRow = computed(() =>
  totalItems.value === 0 ? 0 : (page.value - 1) * limit.value + 1
);
const endRow = computed(() =>
  Math.min(page.value * limit.value, totalItems.value)
);

function formatDateBR(dateISO) {
  if (!dateISO) return '—';
  try {
    const s = String(dateISO).slice(0, 10);
    const [y, m, d] = s.split('-');
    if (!y || !m || !d) return dateISO;
    return `${d}/${m}/${y}`;
  } catch {
    return String(dateISO);
  }
}
function formatDateTimeBR(iso) {
  if (!iso) return 'Pendente';
  try {
    return new Date(iso).toLocaleString('pt-BR');
  } catch {
    return String(iso);
  }
}

function prettifyCode(code) {
  if (!code) return '';
  // fallback simples se não houver label
  return String(code)
    .replace(/^VERMELHO_|^AMARELO_|^VERDE_|^NAO_MONTAR_|^FORA_AULA_/g, '')
    .replaceAll('_', ' ')
    .toLowerCase()
    .replace(/^\w/, c => c.toUpperCase());
}

// (Opcional) Mapa de labels (se quiser ficar idêntico ao modal). Mantive fallback para não ficar gigante.
// Você pode expandir depois com base no dict do modal.
const CODE_LABEL = {
  // Vermelho
  VERMELHO_DOR_CABECA: 'Dor de cabeça',
  VERMELHO_PERDA_MEMORIA: 'Perda de memória',
  VERMELHO_DOR_PESCOCO: 'Dor no pescoço',
  VERMELHO_CONFUSAO_MENTAL: 'Confusão mental',
  VERMELHO_OLHAR_SEM_REACAO_PARALISADO: 'Olhar sem reação/paralisado',
  VERMELHO_DESMAIO: 'Desmaio',
  VERMELHO_DOR_COLUNA: 'Dor na coluna',
  VERMELHO_DOR_FORTE_QUADRIL_SACRO: 'Dor forte no quadril ou sacro',
  VERMELHO_DOR_INTENSA_QUALQUER_MEMBRO: 'Dor intensa em qualquer membro',
  VERMELHO_TONTURA_QUEDA_PRESSAO: 'Tontura e/ou queda de pressão',
  VERMELHO_DOR_FORTE_PEITO: 'Dor forte no peito',
  VERMELHO_LIMITACAO_QUALQUER_MOVIMENTO: 'Limitação de qualquer movimento',
  VERMELHO_FORMIGAMENTO_QUALQUER_MEMBRO: 'Formigamento em qualquer membro',
  VERMELHO_FRATURA_OU_FRATURA_EXPOSTA: 'Fratura ou fratura exposta',

  // Amarelo
  AMARELO_DOR_OMBRO: 'Dor no ombro',
  AMARELO_DOR_PE_OU_TORNOZELO: 'Dor no pé ou tornozelo',
  AMARELO_DOR_BRACO: 'Dor no braço',
  AMARELO_DOR_JOELHO: 'Dor no joelho',
  AMARELO_DOR_TORNOZELO: 'Dor no tornozelo',
  AMARELO_DOR_PUNHOS_OU_MAOS: 'Dor nos punhos ou mãos',

  // Verde
  VERDE_CAIU_EM_PE_SEM_DOR: 'Caiu em pé e não relata dor',
  VERDE_ESCORREGOU_ESTRIBO_CAVALO_PARADO_SEM_DOR: 'Escorregou do estribo com o cavalo parado e não relata dor',

  // Roxo (não pode montar)
  NAO_MONTAR_BATEU_CABECA_CAPACETE: 'Bateu a cabeça (capacete)',
  NAO_MONTAR_CAIU_SENTADO: 'Caiu sentado',
  NAO_MONTAR_CAIU_DE_LADO_CAVALO_MOVIMENTO: 'Caiu de lado com o cavalo em movimento',
  NAO_MONTAR_OMBRO_NO_CHAO: 'Caiu com o ombro no chão',
  NAO_MONTAR_CORTE_OU_RALADO: 'Teve corte ou ralado',
  NAO_MONTAR_CAVALO_PISOU_OU_TROMBOU_AO_CAIR: 'Cavalo pisou ou trombou ao cair',
  NAO_MONTAR_LEVOU_MORDIDA: 'Levou uma mordida',
  NAO_MONTAR_LEVOU_COICE_DE_OUTRO_CAVALO: 'Levou um coice de outro cavalo',
  NAO_MONTAR_EFEITO_CHICOTE_PESCOCO: 'Sofreu um efeito chicote no pescoço',
  NAO_MONTAR_QUEDA_PRESSAO_QUALQUER_MOTIVO: 'Queda de pressão por qualquer motivo',
  NAO_MONTAR_CABECADA_DO_CAVALO: 'Cabeçada do cavalo',
  NAO_MONTAR_QUEDA_NA_CERCA_OU_MURO: 'Queda na cerca ou muro',
  NAO_MONTAR_REFUGO_TROMBAMENTO_OBSTACULO: 'Queda de refugo com trombamento no obstáculo',
  NAO_MONTAR_CAVALO_EMPINA: 'Queda do cavalo empinar',
  NAO_MONTAR_CAVALO_DISPARADO: 'Queda do cavalo disparado',

  // Fora de aula
  FORA_AULA_MORDIDA: 'Mordida',
  FORA_AULA_COICE: 'Coice',
  FORA_AULA_CAVALO_PISAR_NO_ALUNO: 'Cavalo pisar no aluno',
};

function labelFromCode(code) {
  return CODE_LABEL[code] || prettifyCode(code) || String(code);
}

async function urlToDataUrl(url) {
  if (!url) return null;
  const resp = await fetch(url, { mode: 'cors' });
  const blob = await resp.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // data:image/png;base64,...
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function carregarDadosEscola() {
  const empresa = (await axios.get('configuracoes/empresa')).data;

  let estadoSigla = 'UF';
  let municipioNome = 'Cidade não informada';

  if (empresa.estado_cod) {
    const estados = (await axios.get('/localidades/estados')).data;
    const estadoObj = estados.find(e => Number(e.id) === Number(empresa.estado_cod));
    if (estadoObj) estadoSigla = estadoObj.sigla;

    const municipios = (await axios.get(`/localidades/municipios/${empresa.estado_cod}`)).data;
    const municipioObj = municipios.find(m => Number(m.id) === Number(empresa.municipio_cod));
    if (municipioObj) municipioNome = municipioObj.nome;
  }

  return {
    nome: empresa.razao_social,
    slogan: empresa.slogan,
    cnpj: empresa.cnpj,
    endereco: empresa.endereco,
    numero: empresa.numero,
    complemento: empresa.complemento,
    bairro: empresa.bairro,
    municipio: municipioNome,
    estado: estadoSigla,
    cep: empresa.cep,
    telefone: empresa.telefone1,
    whatsapp: empresa.whatsapp_url
  };
}

function montarHeaderPdf(escola, logoDataUrl) {
  const endereco1 = `${escola.endereco || ''}, ${escola.numero || ''}${
    escola.complemento && escola.complemento !== 'null' ? `, ${escola.complemento}` : ''
  } - ${escola.bairro || ''}`;

  const endereco2 = `${escola.municipio || ''} - ${escola.estado || ''}, CEP: ${escola.cep || ''}`;

  const contato = `${escola.telefone ? `Tel: ${escola.telefone}` : ''}${
    escola.whatsapp ? `  |  WhatsApp: ${escola.whatsapp}` : ''
  }`.trim();

  return {
    table: {
      widths: [90, '*'], // 👈 aumentamos espaço da logo
      body: [[
        logoDataUrl
          ? {
              image: logoDataUrl,
              width: 80,          // 👈 LOGO MAIOR (antes era 60)
              margin: [0, 0, 10, 0]
            }
          : { text: '', width: 80 },

        {
          stack: [
            { text: escola.nome || '', style: 'empresaNome' },
            { text: escola.slogan || '', style: 'empresaSlogan' },
            { text: endereco1, style: 'empresaLinha' },
            { text: endereco2, style: 'empresaLinha' },
            { text: contato, style: 'empresaLinha' }
          ],
          alignment: 'right'   // 👈 ALINHADO À DIREITA
        }
      ]]
    },
    layout: 'noBorders',
    margin: [0, 0, 0, 10]
  };
}

function formatAssinatura(sig) {
  if (!sig || !sig.assinado_em) return 'Pendente';
  const nome = sig.nome || '—';
  return `${nome} — ${formatDateTimeBR(sig.assinado_em)}`;
}

function listaItens(titulo, itens, corHex) {
  const arr = Array.isArray(itens) ? itens : [];
  if (arr.length === 0) return [];

  return [
    {
      text: titulo,
      style: 'sectionTitle',
      color: corHex,
      margin: [0, 10, 0, 4],
    },
    {
      ul: arr.map(labelFromCode),
      fontSize: 10,
      margin: [0, 0, 0, 0],
    }
  ];
}



async function gerarPdfProtocolo(item) {
  if (gerandoPdfIds.value.includes(item.id)) return;

  gerandoPdfIds.value.push(item.id);

  try {
    // 1) Busca protocolo completo (com protocolo_json e assinaturas_json)
    const resp = await axios.get(`/operacional/alunos-quedas/${item.id}`);
    const protocolo = resp.data || {};

    const p = protocolo.protocolo_json || {};
    const a = protocolo.assinaturas_json || {};
    const ck = p.checklist || {};
    const recepcao = p?.recepcao || {};
    const cs = recepcao?.comunicado_supervisor || {};
    const cr = recepcao?.contato_responsavel || {};

    // 2) Dados institucionais
    const escola = await carregarDadosEscola();

    const usuarioLogado =
      instance?.appContext?.config?.globalProperties?.$globalState?.userName || 'Usuário';

    const logoUrl =
      instance?.appContext?.config?.globalProperties?.$globalState?.logoPath || '';
    const logoDataUrl = logoUrl ? await urlToDataUrl(logoUrl) : null;

    const headerBlock = montarHeaderPdf(escola, logoDataUrl);

    // 3) Monta conteúdo do checklist (somente itens marcados)
    const partesChecklist = [
      ...listaItens('🔴 Sinais de Alerta Vermelho', ck?.alerta_vermelho?.itens, '#dc3545'),
      ...listaItens('🟡 Sinais de Alerta Amarelo', ck?.alerta_amarelo?.itens, '#ffc107'),
      ...listaItens('🟣 Queda: aluno não pode montar novamente', ck?.queda_nao_pode_montar?.itens, '#6a1b9a'),
      ...listaItens('🟢 Alerta Verde', ck?.alerta_verde_pode_montar?.itens, '#198754'),
      ...listaItens('Situações fora de aula', ck?.situacoes_fora_de_aula?.itens, '#333333'),
    ];

    const dataAula = p?.aula?.data_aula || item?.data_aula || null;

    const agora = new Date();

    const dataFormatada = agora.toLocaleDateString('pt-BR');
    const horaFormatada = agora.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });

    const textoRodape = `Gerado em: ${dataFormatada} às ${horaFormatada} por ${usuarioLogado}`;

    // 4) Documento (pdfmake)
    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 30, 40, 45],

      footer: function(currentPage, pageCount) {
        return {
          margin: [40, 0, 40, 15],
          columns: [
            {
              text: textoRodape,
              fontSize: 8,
              color: '#666'
            },
            {
              text: `${currentPage} / ${pageCount}`,
              alignment: 'right',
              fontSize: 8,
              color: '#666'
            }
          ]
        };
      },

      content: [
        headerBlock,

        { text: 'PROTOCOLO DE QUEDA', style: 'tituloDoc' },

        {
          table: {
            widths: ['*', '*'],
            body: [
              [
                { text: `Aluno: ${protocolo.aluno_nome || item.aluno || '—'}`, style: 'meta' },
                { text: `Matrícula: ${protocolo.matricula_id ?? item.matricula_id ?? '—'}`, style: 'meta' }
              ],
              [
                { text: `Animal: ${item.animal_nome || '—'}`, style: 'meta' },
                { text: `Status: ${protocolo.status || item.status || '—'}`, style: 'meta' }
              ],
              [
                { text: `Data da aula: ${formatDateBR(dataAula)}`, style: 'meta' },
                { text: `Horário: ${p?.aula?.horario ? String(p.aula.horario).slice(0,5) : (item.horario || '—')}`, style: 'meta' }
              ],
              [
                { text: `Turma: ${p?.aula?.turma || item.turma || '—'}`, style: 'meta' },
                { text: `Instrutor: ${p?.aula?.instrutor_nome || item.instrutor || '—'}`, style: 'meta' }
              ],
              [
                { text: `Contato família: ${protocolo.contato_familia ? 'Sim' : 'Não'}`, style: 'meta' },
                { text: `Registro: #${protocolo.id || item.id}`, style: 'meta' }
              ],
            ]
          },
          layout: 'lightHorizontalLines',
          margin: [0, 8, 0, 8]
        },

        { text: 'Descrição do ocorrido', style: 'sectionTitle', margin: [0, 8, 0, 4] },
        { text: p?.descricao_ocorrido || '—', style: 'paragraph' },

        { text: 'Checklist', style: 'sectionTitle', margin: [0, 10, 0, 0] },
        ...(partesChecklist.length ? partesChecklist : [{ text: 'Nenhum item marcado.', style: 'muted' }]),

        { text: 'Recepção', style: 'sectionTitle', margin: [0, 12, 0, 4] },
        {
          table: {
            widths: ['*', '*'],
            body: [
              [
                { text: 'Comunicado ao supervisor', style: 'subTitle' },
                { text: 'Contato com responsável', style: 'subTitle' }
              ],
              [
                {
                  stack: [
                    { text: `Realizado: ${cs.realizado ? 'Sim' : 'Não'}`, style: 'field' },
                    { text: `Meio: ${cs.meio || '—'}`, style: 'field' },
                    { text: `Data/Hora: ${cs.realizado_em ? formatDateTimeBR(cs.realizado_em) : '—'}`, style: 'field' },
                    { text: `Por: ${cs.por || '—'}`, style: 'field' },
                    { text: `Obs.: ${cs.observacao || '—'}`, style: 'field' },
                  ]
                },
                {
                  stack: [
                    { text: `Realizado: ${cr.realizado ? 'Sim' : 'Não'}`, style: 'field' },
                    { text: `Meio: ${cr.meio || '—'}`, style: 'field' },
                    { text: `Data/Hora: ${cr.realizado_em ? formatDateTimeBR(cr.realizado_em) : '—'}`, style: 'field' },
                    { text: `Por: ${cr.por || '—'}`, style: 'field' },
                    { text: `Obs.: ${cr.observacao || '—'}`, style: 'field' },
                  ]
                }
              ]
            ]
          },
          layout: 'lightHorizontalLines'
        },

        { text: 'Assinaturas', style: 'sectionTitle', margin: [0, 12, 0, 4] },
        {
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                { text: 'Instrutor', style: 'subTitle' },
                { text: 'Recepção', style: 'subTitle' },
                { text: 'Supervisor', style: 'subTitle' },
              ],
              [
                { text: formatAssinatura(a?.instrutor), style: a?.instrutor?.assinado_em ? 'field' : 'pending' },
                { text: formatAssinatura(a?.recepcao),  style: a?.recepcao?.assinado_em  ? 'field' : 'pending' },
                { text: formatAssinatura(a?.supervisor),style: a?.supervisor?.assinado_em ? 'field' : 'pending' },
              ]
            ]
          },
          layout: 'lightHorizontalLines',
        },
      ],

      styles: {
        tituloDoc: { fontSize: 16, bold: true, alignment: 'center', margin: [0, 4, 0, 8] },
        empresaNome: { fontSize: 12, bold: true, margin: [0, 0, 0, 2] },
        empresaSlogan: { fontSize: 10, italics: true, margin: [0, 0, 0, 4] },
        empresaLinha: { fontSize: 9, margin: [0, 0, 0, 1] },
        meta: { fontSize: 10, margin: [0, 2, 0, 2] },
        sectionTitle: { fontSize: 13, bold: true },
        subTitle: { fontSize: 10, bold: true, fillColor: '#f2f2f2', margin: [0, 4, 0, 4] },
        paragraph: { fontSize: 10, margin: [0, 0, 0, 0] },
        field: { fontSize: 9, margin: [0, 1, 0, 1] },
        pending: { fontSize: 9, margin: [0, 1, 0, 1], color: '#888' },
        muted: { fontSize: 8, color: '#777' }
      }
    };

    pdfMake.createPdf(docDefinition).download(`Protocolo_Queda_${protocolo.id || item.id}.pdf`);
  } catch (err) {
    console.error('Erro ao gerar PDF:', err);
    alert('Não foi possível gerar o PDF.');
  } finally {
    gerandoPdfIds.value = gerandoPdfIds.value.filter(id => id !== item.id);
  }
}

watch(page, () => load());
watch(limit, (nv, ov) => {
  if (nv !== ov) {
    page.value = 1;
    load();
  }
});

// filtros iniciais
Object.assign(f.value, {
  aluno: '',
  instrutor: '',
  data_inicio: '', 
  data_fim: '', 
  status: '',
  nivel_cor: '',
  contato_familia: ''
});

function filtrar() {
  page.value = 1;
  load();
}

function limparFiltros() {
  page.value = 1;
  Object.assign(f.value, {
    aluno: '',
    instrutor: '',
    data_inicio: '', 
    data_fim: '', 
    status: '',
    nivel_cor: '',
    contato_familia: ''
  });
  load();
}

// Modal
const showModalProtocoloQueda = ref(false);
const selectedProtocoloQueda = ref(null);
const gerandoPdfIds = ref([]);

async function abrirProtocolo(item) {
  try {
    const resp = await axios.get(`/operacional/alunos-quedas/${item.id}`);
    selectedProtocoloQueda.value = resp.data;
    showModalProtocoloQueda.value = true;
  } catch (err) {
    console.error('Erro ao abrir protocolo:', err);
    alert('Não foi possível abrir o protocolo.');
  }
}

function fecharModalProtocolo() {
  showModalProtocoloQueda.value = false;
  selectedProtocoloQueda.value = null;
  load(); // recarrega a listagem
}

function isGerandoPdf(item) {
  return gerandoPdfIds.value.includes(item.id);
}

function canGerarPdf(item) {
  return item.status === 'CONCLUIDO' && !isGerandoPdf(item);
}

function pdfIconClass(item) {
  if (isGerandoPdf(item)) {
    return 'bi bi-hourglass-split text-secondary';
  }

  return [
    'bi',
    'bi-file-earmark-pdf',
    'text-danger',
    { 'disabled-icon': item.status !== 'CONCLUIDO' }
  ];
}

function pdfTitle(item) {
  if (isGerandoPdf(item)) return 'Gerando PDF...';
  return item.status === 'CONCLUIDO'
    ? 'Gerar PDF'
    : 'Disponível apenas quando concluído';
}

async function onClickGerarPdf(item) {
  if (!canGerarPdf(item)) return;
  await gerarPdfProtocolo(item);
}

function onSalvouProtocolo() {
  load(); // recarrega listagem quando salvar/assinar/concluir
}

onMounted(() => {
  page.value = 1;
  load();
});
</script>

<style scoped>

.disabled-icon {
  opacity: 0.4;
  cursor: not-allowed !important;
}

:deep(.pagination.pagination-sm .page-link) {
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}

/* bolinhas de severidade */
.dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.dot.vermelho { background: #dc3545; }
.dot.amarelo  { background: #ffc107; }
.dot.roxo     { background: #6a1b9a; }
.dot.verde    { background: #198754; }
.dot.normal   { background: #6c757d; }

.icon-loading {
  opacity: 0.6;
  pointer-events: none;
}
</style>